/**
 * Signed lease → lease record (server flag LEASE_INTAKE_ENABLED; 404 when off).
 */

import api from '../../api';

export const MAX_LEASE_FILE_BYTES = 15 * 1024 * 1024;

/** Reading a whole lease with AI can take most of a minute. */
export const READ_TIMEOUT_MS = 150 * 1000;

/** { aiEnabled, maxFiles, intakes } — uploads still waiting for review. Throws 404 when the feature is off. */
export async function listLeaseIntakes() {
  const res = await api.get('/api/lease-intakes');
  return res.data;
}

/**
 * @param {File[]} files - one PDF, or page photos in order
 * @param {string} propertyId
 * @param {'camera'|'photo_library'|'file_upload'} sourceType
 * @param {(percent: number) => void} [onProgress]
 */
export async function uploadLeaseIntake(files, propertyId, sourceType, onProgress) {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  form.append('propertyId', propertyId);
  form.append('sourceType', sourceType);
  const res = await api.post('/api/lease-intakes', form, {
    onUploadProgress: (event) => {
      if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100));
    }
  });
  return res.data;
}

/** The upload plus `previews` ({ mimeType, fileName, previewUrl }) that expire after 15 minutes. */
export async function getLeaseIntake(id) {
  const res = await api.get(`/api/lease-intakes/${id}`);
  return res.data;
}

/** Body must be {}: a null body is sent as JSON "null", which the API's JSON parser rejects. */
export async function readLeaseIntake(id) {
  const res = await api.post(`/api/lease-intakes/${id}/read`, {}, { timeout: READ_TIMEOUT_MS });
  return res.data;
}

/** Creates the lease. Returns { lease, created }; repeating it returns the same lease. */
export async function confirmLeaseIntake(id, lease) {
  const res = await api.post(`/api/lease-intakes/${id}/confirm`, lease);
  return res.data;
}

export async function discardLeaseIntake(id) {
  const res = await api.post(`/api/lease-intakes/${id}/discard`, {});
  return res.data;
}
